import { Button, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const SearchStyledComponents = {
  StyledSearchButton: styled(Button)(({ theme }) => ({
    width: '50%',
    maxWidth: '150px',
    height: '50px',
    color: theme.palette.accent.contrastText,
    background: theme.palette.accent.main,
    marginTop: '20px',
    '&:hover': {
      background: theme.palette.accent.main
    }
  })),
  StyledForm: styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '50px'
  }),
  StyledTextField: styled(TextField)({
    width: '100%',
    maxWidth: '300px',
    marginTop: '10px',
    '& input': {
      WebkitAppearance: 'none',
      margin: '0'
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: '0'
    }
  })
};

export default SearchStyledComponents;
